@charset "UTF-8";
/*!
 *   Copyright 2022-2023  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
/*!
 *   Copyright 2022  SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
/*!
 *   Copyright 2022-2024 SenX S.A.S.
 *
 *   Licensed under the Apache License, Version 2.0 (the "License");
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
.gts-classname {
  font-size: var(--warp-view-font-size, 1rem);
  color: var(--gts-classname-font-color, #004eff);
}

.gts-labelname {
  font-size: var(--warp-view-font-size, 1rem);
  color: var(--gts-labelname-font-color, #19A979);
}

.gts-attrname {
  font-size: var(--warp-view-font-size, 1rem);
  color: var(--gts-attrname-font-color, #ED4A7B);
}

.gts-separator {
  font-size: var(--warp-view-font-size, 1rem);
  color: var(--gts-separator-font-color, #a0a0a0);
}

.gts-labelvalue {
  font-size: var(--warp-view-font-size, 1rem);
  color: var(--gts-labelvalue-font-color, #000000);
  font-style: italic;
}

.gts-attrvalue {
  font-size: var(--warp-view-font-size, 1rem);
  color: var(--gts-attrvalue-font-color, #000000);
  font-style: italic;
}

:host table {
  width: 100%;
  color: var(--warp-view-font-color, #404040);
  table-layout: auto;
}
:host table input[type=text].discovery-input {
  display: inline-block;
  font-size: var(--warp-view-input-font-size, 1rem);
  border-radius: var(--warp-view-input-border-radius, 0.25rem);
  border: 1px solid var(--warp-view-input-border-color, #c0c0c0);
  color: var(--warp-view-input-label-color, #404040);
  background-color: var(--warp-view-input-bg-color, #ffffff);
  vertical-align: middle;
  width: calc(100% - var(--warp-view-datagrid-cell-padding, 5px));
  height: 34px;
  padding: 1px 5px;
  margin-left: calc(var(--warp-view-datagrid-cell-padding, 5px) * -1);
}
:host table th.pointer {
  cursor: pointer;
}
:host table th.sortable.asc::after {
  content: "▲";
  margin-right: 3px;
}
:host table th.sortable.desc::after {
  margin-right: 3px;
  content: "▼";
}
:host table td, :host table th {
  padding: var(--warp-view-datagrid-cell-padding, 5px);
  text-align: left;
  white-space: nowrap;
  font-size: var(--warp-view-font-size, 1rem);
}
:host table th:last-child {
  width: 100% !important;
}
:host table .odd {
  background-color: var(--warp-view-datagrid-odd-bg-color, #ffffff);
  color: var(--warp-view-datagrid-odd-color, #404040);
}
:host table .even {
  background-color: var(--warp-view-datagrid-even-bg-color, #c0c0c0);
  color: var(--warp-view-datagrid-even-color, #000000);
}
:host .center {
  text-align: center;
}
:host .center .pagination {
  display: inline-block;
}
:host .center .pagination .index, :host .center .pagination .next, :host .center .pagination .prev {
  color: var(--warp-view-font-color, #404040);
  float: left;
  padding: 8px 16px;
  text-decoration: none;
  transition: background-color 0.3s;
  border: 1px solid var(--warp-view-pagination-border-color, #c0c0c0);
  margin: 0;
  cursor: pointer;
  background-color: var(--warp-view-pagination-bg-color, #ffffff);
}
:host .center .pagination .index.active, :host .center .pagination .next.active, :host .center .pagination .prev.active {
  background-color: var(--warp-view-pagination-active-bg-color, #4CAF50);
  color: var(--warp-view-pagination-active-color, #ffffff);
  border: 1px solid var(--warp-view-pagination-active-border-color, #4CAF50);
}
:host .center .pagination .index.hoverable:hover, :host .center .pagination .next.hoverable:hover, :host .center .pagination .prev.hoverable:hover {
  background-color: var(--warp-view-pagination-hover-bg-color, #c0c0c0);
  color: var(--warp-view-pagination-hover-color, #000000);
  border: 1px solid var(--warp-view-pagination-hover-border-color, #c0c0c0);
}
:host .center .pagination .index.disabled, :host .center .pagination .next.disabled, :host .center .pagination .prev.disabled {
  cursor: auto;
  color: var(--warp-view-pagination-disabled-color, #c0c0c0);
}
:host .round {
  border-radius: 50%;
  background-color: #bbbbbb;
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid #454545;
}
:host ul {
  list-style: none;
}